import styled from 'styled-components';
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";

export const HeaderStyles = styled.header`
    @media screen and (min-width: ${variables.mobile_width_percentage}px) {
        header {
            color: #05282f;
            display: flex;
            font-family: "acumin-pro", Helvetica, Arial, sans-serif;
            justify-content: space-between;
            margin-bottom: 5px;
            z-index: 1000;

            .clayton-logo {
                width: 125px;
                height: 45px;
                margin-top: 10px;
                margin-left: 9px;
                .hat {
                    fill: #a1ce66;
                }
                .letters {
                    fill: #1377bc;
                }   
            }
            p {
                font-size: 16px;
                margin-top: 27px;
                margin-right: 15px;
            }
            a {
                text-decoration: none;
            }
            span {
                color: #40b0f7;
            }
        }  
    }
    
    @media screen and (min-width: 768px) {
        header {
            margin-top: 0px;
            margin-left: 3px;
            margin-bottom: 10px;

            .clayton-logo {
                height: 60px;
            }
            p {
                font-size: 21px;
                margin-top: 35px;
                margin-right: 15px;
            }
        }  
    }

    @media screen and (min-width: ${variables.desktop_container_maxwidth}px) {
        max-width: 1100px;
        margin: 0 auto;
    }
`;